import Fuse from "fuse.js";

// Parameters:
// -----------
//
// Returns
// -----------
// Fusejs Search Config for Instance table
export const fuseConfigInstances = {
  keys: [
    {
      name: "instance_name",
      weight: 0.9
    },
    {
      name: "id",
      weight: 0.7
    },
    {
      name: "description",
      weight: 0.7
    }
  ],
  includeScore: true,
  shouldSort: true,
  threshold: 0.36,
  findAllMatches: true
};
// Parameters:
// -----------
// search
// list
//
// Returns
// -----------
// List of Instance filtered by Fusejs
export const searchInstanceTableFilterHelper = (search, list) => {
  let result = list;
  if (search !== "" && search !== null) {
    const fuse = new Fuse(list, fuseConfigInstances);
    result = fuse.search(search).map((res) => res.item);
  }
  return result;
};

// Parameters:
// -----------
//
// Returns
// -----------
// Fusejs Search Config for Category Instance table
export const fuseConfigCategoryInstances = {
  keys: [
    {
      name: "name",
      weight: 0.9
    },
    {
      name: "id",
      weight: 0.7
    }
  ],
  includeScore: true,
  shouldSort: true,
  threshold: 0.36,
  findAllMatches: true
};
// Parameters:
// -----------
// search
// list
//
// Returns
// -----------
// List of Category Instance filtered by Fusejs
export const searchCategoryTableFilterHelper = (search, list) => {
  let result = list;
  if (search !== "" && search !== null) {
    const fuse = new Fuse(list, fuseConfigCategoryInstances);
    result = fuse.search(search).map((res) => res.item);
  }
  return result;
};
